module.exports = __webpack_public_path__ + "static/media/lumenlife-2.5a9df0f0.jpg";